<template>
  <div>
    <div class="container wincourse-bind-box">
      <el-steps :active="activeStep" simple>
        <el-step title="账号验证" icon=" ">
          <div slot="icon" v-if="activeStep > 0">
            <icon name="right" :w="20" :h="20"></icon>
          </div>
        </el-step>
        <el-step title="确认个人信息" icon=" ">
          <div slot="icon" v-if="activeStep > 1">
            <icon name="right" :w="20" :h="20"></icon>
          </div>
        </el-step>
        <el-step title="绑定/创建成功" icon=" ">
          <div slot="icon" v-if="activeStep >= 2">
            <icon name="right" :w="20" :h="20"></icon>
          </div>
        </el-step>
      </el-steps>

      <div style="padding: 0 10px">
        <br>
        <el-row type="flex" justify="center">
          <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            <validate-user v-show="activeStep === 0" @cancel="handleCancel" @validate-ok="userValidateOk"></validate-user>
            <wincourse-user-info v-show="activeStep === 1" :bind="bindUser" :win-course-token="winCourseToken" :default-data="wincourseUserInfo" @cancel="activeStep--" @bind-success="onBindSuccess"></wincourse-user-info>
            <el-empty v-if="activeStep === 2" :description="`信息更新成功，${runSeconds}秒后自动跳转云课时间`" :image-size="254" :image="require('@/assets/imgs/wincourse/wincourse-empty.png')">
              <el-button type="primary" @click="handleToCourseDetailPage">立即跳转</el-button>
            </el-empty>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>

<script>
import ValidateUser from "./ValidateUser";
import WincourseUserInfo from "./WincourseUserInfo";
import { mapGetters } from "vuex";
import { handleToCourseDetailPage } from "@/wincourse/mixins/WincourseMixin";
import { getWincourseTicket } from "@/api/auth/jwt";

export default {
  name: "CreateOrBindUser",
  components: {
    ValidateUser,
    WincourseUserInfo,
  },
  data() {
    return {
      activeStep: 0,
      runSeconds: 0,
      timer: null,
      bindUser: false,
      winCourseToken: "",
      wincourseUserInfo: {},
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    handleCancel() {
      this.$router.go(-1);
    },
    userValidateOk(userInfo) {
      let wToken = null
      if (!userInfo) {
        let { username, nickname, name, mobile, email, sex, deptName } =
          this.userInfo;
        // 无用户，创建
        userInfo = {
          username: `ultralab_${username}`,
          college: deptName, // 学校信息填充
          realname: name,
          nickName: nickname,
          phone: mobile,
          email,
          sex: [1, 2].includes(sex) ? sex : 1,
        };
        // 默认密码与账号相同
        // userInfo.password = userInfo.username
        this.bindUser = false;
      } else {
        wToken = userInfo.token
        this.bindUser = true;
      }
      this.wincourseUserInfo = userInfo;
      this.winCourseToken = wToken
      this.activeStep++;
    },
    onBindSuccess() {
      this.activeStep++;
      this.startInterval();
    },
    /**
     * 跳转倒计时
     */
    startInterval() {
      this.runSeconds = 5;
      this.clearImmediate();
      this.timer = setInterval(this.intervalFun, 1000);
    },
    intervalFun() {
      if (this.runSeconds > 0) {
        this.runSeconds--;
      } else {
        this.clearImmediate();
        this.handleToCourseDetailPage();
      }
    },
    handleToCourseDetailPage() {
      // 云课时间课程
      let { courseId } = this.$route.query;
      // 获取ticket
      this.getTicket(courseId).then((ticket) => {
        this.$router.go(-1);
        handleToCourseDetailPage(courseId, ticket);
      });
    },
    getTicket(courseId) {
      return getWincourseTicket(courseId);
    },
    /**
     * 停止倒计时
     */
    clearImmediate() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
  beforeDestroy() {
    this.clearImmediate();
  },
};
</script>
<style lang="less">
.wincourse-bind-box {
  margin-top: 50px;
  .el-step__head .is-process {
    color: #333333;
    font-weight: bold;
  }
  .el-step__title .is-process {
    color: #333333;
    font-weight: bold;
  }
  .el-step__head.is-success {
    color: #14b41e;
    font-weight: bold;
  }
  .el-step__title.is-success {
    color: #14b41e;
    font-weight: bold;
  }
  .el-step__title.is-wait{
    color: #333333;
    font-weight: bold;
  }
}
</style>
